import "./Assignment.scss";
import Button from "core/buttons/button/Button";
import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useUserContext } from "api/user/UserProvider";
import {
  ASSIGNMENT_RESPONSE_OPTIONS,
  FILTERS_FOR_NAMES,
  LANG,
  QUERY_STATUS,
} from "constants/constants";
import { useClientContext } from "api/directory/client/ClientProvider";
import ValidationModal from "components/modal/ValidationModal";
import { ASSIGNMENT_RESPONSE_COMMENT } from "constants/forms";
import InputTextArea from "core/inputs/input-text-area/InputTextArea";

const Assignment = () => {
  const {
    updateAnswerAssignment,
    getAssignmentyRequestAnswer,
    assignmentRequestAnswer,
    updateAnswerAssignmentStatus,
    setUpdateAnswerAssignmentStatus,
    getAssignmentyRequestAnswerQueryStatus,
  } = useClientContext();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { lang, userScope } = useUserContext();
  const [isOpen, setIsOpen] = useState(false);
  const [isCommentInputOpened, setIsCommentInputOpened] = useState(false);
  const [assignmentResponseComment, setAssignmentResponseComment] =
    useState(null);
  const clientId = searchParams.get("client-id");
  const prospectionId = searchParams.get("prospection-id");
  const requesterId = searchParams.get("requester-id");

  useEffect(() => {
    if (
      (clientId?.length > 0 || prospectionId?.length > 0) &&
      requesterId?.length > 0
    ) {
      getAssignmentyRequestAnswer({
        id: clientId || prospectionId,
        requester_id: requesterId,
        assignment_type: clientId
          ? FILTERS_FOR_NAMES.CLIENT
          : FILTERS_FOR_NAMES.PROSPECTION,
      });
    }
  }, [clientId, prospectionId, requesterId]);

  const formattedMessage = () => {
    const isFrench = lang === LANG.FR;
    const requesterName = assignmentRequestAnswer?.requester_name;
    const entityType = assignmentRequestAnswer?.client_name
      ? "client"
      : "prospect";
    const entityName =
      assignmentRequestAnswer?.client_name ||
      assignmentRequestAnswer?.prospection_name;
    return (
      <p>
        {isFrench
          ? "Que souhaitez-vous répondre à "
          : "How would you like to respond to "}
        <span>{requesterName}</span>
        {isFrench
          ? " pour sa demande d'assignation au "
          : "'s request for assignment to "}
        {entityType} <span>{entityName}</span> ?
      </p>
    );
  };

  const assignmenResponseHandler = (response) => {
    updateAnswerAssignment({
      answer_id: assignmentRequestAnswer?.answer_id,
      answer: response,
      refusal_reason: assignmentResponseComment,
      assignment_type: assignmentRequestAnswer?.client_name
        ? FILTERS_FOR_NAMES.CLIENT
        : FILTERS_FOR_NAMES.PROSPECTION,
    });
  };

  useEffect(() => {
    if (updateAnswerAssignmentStatus === QUERY_STATUS.SUCCESS) {
      setIsOpen(true);
    }
  }, [updateAnswerAssignmentStatus]);

  return (
    <>
      <ValidationModal
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
          setUpdateAnswerAssignmentStatus(QUERY_STATUS.INITIAL);
          navigate(`/${userScope}/dashboard`);
        }}
        messages={{
          pendingTitleId: "assignment_title",
          pendingMessageId: "assignment_pending",
          successTitleId: "assignment_title",
          successMessageId: "response_taken_into_account",
        }}
        status={updateAnswerAssignmentStatus}
      />
      {getAssignmentyRequestAnswerQueryStatus === QUERY_STATUS.SUCCESS && (
        <div className="assignment-page">
          {assignmentRequestAnswer?.answer_date ? (
            <>
              <div className="title">
                <FormattedMessage
                  id="assignment_request_already_replied"
                  defaultMessage="Vous avez déjà répondu à cette demande d'assignation."
                />
              </div>
              <Button
                color="btn-standard gray-700"
                type="link"
                to={`/${userScope}/dashboard`}
              >
                <FormattedMessage
                  id="button_back_dash"
                  defaultMessage="Retourner sur le dashboard"
                />
              </Button>
            </>
          ) : (
            <>
              <div className="title">
                <FormattedMessage
                  id="assignment_request"
                  defaultMessage="Demande d'assignation"
                />
              </div>
              <div className="text-2">{formattedMessage()}</div>
              <div className="buttons">
                <Button
                  color="white"
                  type="link"
                  className="btn-standard green"
                  onClick={() =>
                    assignmenResponseHandler(ASSIGNMENT_RESPONSE_OPTIONS.YES)
                  }
                >
                  <FormattedMessage id="yes" defaultMessage="Oui" />
                </Button>
                {!assignmentRequestAnswer?.current_mission_count > 0 && (
                  <Button
                    color="white"
                    type="link"
                    className="btn-standard orange"
                    onClick={() =>
                      assignmenResponseHandler(
                        ASSIGNMENT_RESPONSE_OPTIONS.YES_AND_DETACH
                      )
                    }
                  >
                    <FormattedMessage
                      id={
                        assignmentRequestAnswer?.client_name
                          ? "yes_and_detach_client"
                          : "yes_and_detach_prospection"
                      }
                      defaultMessage="Oui, mais je ne veux plus être sur cette prospection/client"
                    />
                  </Button>
                )}
                <Button
                  color="white"
                  type="link"
                  className="btn-standard red"
                  onClick={() => setIsCommentInputOpened(true)}
                >
                  <FormattedMessage id="no" defaultMessage="Non" />
                </Button>
              </div>
              {isCommentInputOpened && (
                <>
                  <InputTextArea
                    id="assignment_comment"
                    label={ASSIGNMENT_RESPONSE_COMMENT}
                    value={assignmentResponseComment}
                    onChange={(val) => {
                      setAssignmentResponseComment(val?.target?.value);
                    }}
                    required
                    className="comment-area"
                    dynamicHeight={true}
                    width={"600px"}
                  />
                  <Button
                    color="btn-medium gray-700"
                    type="submit"
                    id="button-comment-validation"
                    disabled={
                      !assignmentResponseComment ||
                      assignmentResponseComment?.length === 0
                    }
                    onClick={() => {
                      assignmenResponseHandler(ASSIGNMENT_RESPONSE_OPTIONS.NO);
                      setIsCommentInputOpened(false);
                    }}
                  >
                    <FormattedMessage
                      id="confirm_answer"
                      defaultMessage="Confirmer la réponse"
                    />
                  </Button>
                </>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
};

export default Assignment;
